import { SnackSnsType } from "@/lib/gql/__generated__/graphql";

import type { SnackBlocksFormModelMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods";
import type { SnackBlocksFormModelSNSMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods/sns";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import Facebook from "@/components/ui/icon/sns/facebook";
import Instagram from "@/components/ui/icon/sns/instagram";
import Line from "@/components/ui/icon/sns/line";
import Note from "@/components/ui/icon/sns/note";
import Threads from "@/components/ui/icon/sns/threads";
import Tiktok from "@/components/ui/icon/sns/tiktok";
import X from "@/components/ui/icon/sns/x";
import Youtube from "@/components/ui/icon/sns/youtube";

type Props = {
	snsIcon: SnackBlocksFormModelSNSMethodsType["snsIcons"]["value"][number];
	onSetIsSelectedToSNSIcons: SnackBlocksFormModelMethodsType["SNSMethods"]["onSetIsSelectedToSNSIcons"];
	onSetSNSURLToSnsIcons: SnackBlocksFormModelMethodsType["SNSMethods"]["onSetSNSURLToSnsIcons"];
};

export const SNSIconsSectionListItem = ({ snsIcon, onSetIsSelectedToSNSIcons, onSetSNSURLToSnsIcons }: Props) => {
	const { selected, snsType, url } = snsIcon;

	return (
		<div className="flex items-center gap-x-6">
			<div className="flex items-center gap-x-3">
				<CheckboxField
					value={selected.value}
					errorMessage={selected.error}
					label={""}
					handleChange={() => {
						onSetIsSelectedToSNSIcons(snsIcon.snsType.value);
					}}
				/>
				{snsType.value === SnackSnsType.Facebook ? (
					<Facebook />
				) : snsType.value === SnackSnsType.Instagram ? (
					<Instagram />
				) : snsType.value === SnackSnsType.Twitter ? (
					<X />
				) : snsType.value === SnackSnsType.Youtube ? (
					<Youtube />
				) : snsType.value === SnackSnsType.Line ? (
					<Line />
				) : snsType.value === SnackSnsType.Note ? (
					<Note />
				) : snsType.value === SnackSnsType.Tiktok ? (
					<Tiktok />
				) : snsType.value === SnackSnsType.Threads ? (
					<Threads />
				) : null}
			</div>
			<InputTextField
				className="flex-1"
				value={url.value}
				errorMessage={url.error}
				handleChange={(input) => onSetSNSURLToSnsIcons(snsType.value, input)}
			/>
		</div>
	);
};

SNSIconsSectionListItem.displayName = "SNSIconsSectionListItem";
